<template>
  <common-setting-form
    :common-setting-data="commonSettingData"
    page-type="setup"
    @updateEditData="updateEditData"
  />
</template>

<script>
import CommonSettingForm from '../../SmartScheduling/components/CommonSettingForm.vue'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CommonSettingForm
  },
  data: () => ({
    ...mapGetters('scheduling', [
      'getCompanySettingData'
    ]),
    ...mapState([
      'timezone'
    ]),
    ...mapState('auth', [
      'customerName'
    ]),
    ...mapState('scheduling', [
      'dayPlanNg',
      'dayPlanOk',
      'timePlanNg',
      'timePlanOk',
      'sharingAdjustmentNg',
      'sharingAdjustmentOk',
      'workHourSetting'
    ])
  }),
  computed: {
    ...mapState('auth', [
      'uid',
      'isNewUser'
    ]),
    commonSettingData() {
      return this.getCompanySettingData()
    }
  },
  methods: {
    ...mapActions('scheduling', [
      'loadCompanySetting'
    ]),
    updateEditData(data) {
      this.$emit('updateSchedulingCommon', data)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
